import { JsEnv } from "../../models/js_env";
import { RegularDeliveryJsEnv } from "../../models/regular_delivery/regular_delivery_js_env";
import { RegularDeliveryContainer } from "../../views/pc/regular_delivery/regular_delivery_container";

export class RegularDeliveryAction {
  private static regularDeliveryJsEnv: RegularDeliveryJsEnv

  static init(env: JsEnv) {
    this.regularDeliveryJsEnv = new RegularDeliveryJsEnv(env.PAGE.isLogin, env.SITE_TYPE)
    new RegularDeliveryContainer(); // NOSONAR
  }

  /**
   * 定期配送サービス お申込み確認画面へ遷移
   */
  static movePageToRegularDeliveryApply(catalogItemCode: string, regularDeliveryCatalogItemCode: string) {
    window.location.href = this.regularDeliveryJsEnv.makeRegularDeliveryUrl(catalogItemCode, regularDeliveryCatalogItemCode)
  }
}
